import { render, staticRenderFns } from "./product-image-viewer.vue?vue&type=template&id=78f027d9&scoped=true&"
import script from "./product-image-viewer.vue?vue&type=script&lang=js&"
export * from "./product-image-viewer.vue?vue&type=script&lang=js&"
import style0 from "./product-image-viewer.vue?vue&type=style&index=0&id=78f027d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../MultiSiteClient/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f027d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../MultiSiteClient/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VCol,VImg,VRow})
